export const pageRatio = 0.62;

// export const DEFAULT_BANNER = 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/warmup_default.jpg';
export const DEFAULT_BANNER = 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/w/warmup_en_kwai.jpg';
export const DEFAULT_SHARE = 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/w/warmup_share_en_kwai.jpg';

export const BANNER_TOTAL_MAP = {
    egy: {
        'ar': 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/w/warmup_ar.jpg',
        'en': 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/w/warmup_en_kwai.jpg',
    },
    pak: {
        'en': 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/w/warmup_en_sv.jpg',
    },
    in: {
        'id': 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/w/warmup_id.jpg',
        'en': 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/w/warmup_en_sv.jpg',
    },
    tur: {
        'tr': 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/w/warmup_tur.jpg',
        'en': 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/w/warmup_en_kwai.jpg',
    },
    br: {
        'pt': 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/w/warmup_br.jpg',
        'en': 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/w/warmup_en_kwai.jpg',
    },
};

export const SHARE_TOTAL_MAP = {
    egy: {
        ar: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/w/warmup_share_ar.jpg',
        en: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/w/warmup_share_en_kwai.jpg',
    },
    pak: {
        en: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/w/warmup_share_en_sv.jpg',
    },
    in: {
        id: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/w/warmup_share_id.jpg',
        en: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/w/warmup_share_en_sv.jpg',
    },
    tur: {
        tr: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/w/warmup_share_tur.jpg',
        en: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/w/warmup_share_en_kwai.jpg',
    },
    br: {
        pt: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/w/warmup_share_br.jpg',
        en: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/w/warmup_share_en_kwai.jpg',
    },
};

export const LAUNCH_OPTION_PARAM = '&__launch_options__=%7B%22topBarPosition%22%3A%22fixed%22%7D&isLiving=true';

export const PAGE_MY = `/global-warmup/my?hyId=global-warmup&liveWHRatio=${pageRatio}&livesec=1&source=WARMUP`; // 二级页

export const PAGE_RULE = `/global-midyear/rule?hyId=global-warmup&liveWHRatio=${pageRatio}&livesec=1&rankPeriod=FINAL&roleType=anchor&source=WARMUP`; // 二级页

export const PAGE_HOME = `/global-warmup/home?hyId=global-warmup&liveWHRatio=${pageRatio}`; // 分享回流到个人页 点击按钮去主页

export const PAGE_HOME_ONLINE = `/global-midyear/home?hyId=global-midyear&liveWHRatio=${pageRatio}`;

export const PAGE_RECORD = `/global-warmup/record?hyId=global-warmup&liveWHRatio=${pageRatio}&source=WARMUP`;

export const PAGE_SHARE_PARAMS = '&hyId=global-warmup&activityName=global-warmup&source=WEB_SHARE';

// 端外唤醒端内
export const PAGE_BACK_FLOW_HOME = '/global-warmup/home?hyId=global-warmup&source=SHARE&need_login=true&loginCheck=1';

export const PAGE_BACK_FLOW_MY = '/global-warmup/my?hyId=global-warmup&source=SHARE&need_login=true&loginCheck=1';

/* eslint-disable no-template-curly-in-string */
export enum TaskTypeEnum {
    VIEW = 'VIEW',
    SHARE = 'SHARE',
    SHARE_OPENED = 'SHARE_OPENED',
    FOLLOW = 'FOLLOW',
    FANS = 'FANS',
    OFFICIAL = 'OFFICIAL',
}

export const missionInfo = {
    [TaskTypeEnum.VIEW]: {
        text: 'k_333274',
        btnText: 'k_333276',
        doneText: 'k_333281',
    },
    [TaskTypeEnum.SHARE]: {
        text: 'k_333278',
        btnText: 'k_333277',
        doneText: 'k_333281',
    },
    [TaskTypeEnum.FOLLOW]: {
        text: 'k_333283',
        btnText: 'k_333276',
        doneText: 'k_333281',
    },
    [TaskTypeEnum.FANS]: {
        text: 'k_333286',
        btnText: 'k_333287',
        doneText: 'k_333281',
    },
    [TaskTypeEnum.OFFICIAL]: {
        text: 'k_333290',
        btnText: 'k_333284',
        doneText: 'k_333289',
    },
} as Record<TaskTypeEnum, {text: string, btnText: string, doneText: string}>;


export const SHARE_CAPTION = 'k_355215';

export const BUCKET_MAP = {
    br: 'k_342128',
    tur: 'k_342127',
    pak: 'k_342126',
    in: 'k_342125',
    egy: 'k_342124',
    spa: 'k_362594',
} as const;

export const getBucketText = (bucket: string) => {
    // eslint-disable-next-line no-underscore-dangle
    return window?.__$k18n({id: BUCKET_MAP[bucket as keyof typeof BUCKET_MAP]}) || '';
};

// 票数明细枚举
export enum DETAIL_TYPE_ENUM {
    'VIEW' = 'VIEW',
    'SHARE' = 'SHARE',
    'SHARE_OPENED' = 'SHARE_OPENED',
    'FOLLOW' = 'FOLLOW',
    'FANS' = 'FANS',
    'OFFICIAL' = 'OFFICIAL',
    'VOTE_TO' = 'VOTE_TO',
    'VOTE_FROM' = 'VOTE_FROM',
}

export const DETAIL_TYPE_MAP = {
    [DETAIL_TYPE_ENUM.VIEW]: 'k_336708',
    [DETAIL_TYPE_ENUM.SHARE]: 'k_336709',
    [DETAIL_TYPE_ENUM.SHARE_OPENED]: 'k_336710',
    [DETAIL_TYPE_ENUM.FOLLOW]: 'k_336712',
    [DETAIL_TYPE_ENUM.FANS]: 'k_336711',
    [DETAIL_TYPE_ENUM.OFFICIAL]: 'k_336713',
};

// 决赛 第一组 第一名 特殊奖励
export const rewardConfigEgy = [
    {
        type: 'apple_reward',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/apple_small.png',
        nameK: 'k_344397',
    },
    {
        type: 'giftName',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/name_ar.png',
        nameK: 'k_362580',
    },
    {
        type: 'kaiping',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/kaiping_7_ar.png',
        nameK: 'k_342131',
    },
    {
        type: 'banner',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/banner_15_ar.png',
        nameK: 'k_342284',
    },
    {
        type: 'extra',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/extra_50_5.png',
        nameK: 'k_362584',
        extraA: 50,
        extraB: 5,
    },
];

export const rewardConfigIn = [
    {
        type: 'apple_reward',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/apple_small.png',
        nameK: 'k_344397',
    },
    {
        type: 'giftName',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/name_en.png',
        nameK: 'k_362580',
    },
    {
        type: 'kaiping',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/kaiping_7_id.png',
        nameK: 'k_342131',
    },
    {
        type: 'banner',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/banner_15_id.png',
        nameK: 'k_342284',
    },
    {
        type: 'extra',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/extra_50_5.png',
        nameK: 'k_362584',
        extraA: 50,
        extraB: 5,
    },
];

export const rewardConfigPak = [
    {
        type: 'apple_reward',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/apple_small.png',
        nameK: 'k_344397',
    },
    {
        type: 'giftName',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/name_en.png',
        nameK: 'k_362580',
    },
    {
        type: 'kaiping',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/kaiping_7_en.png',
        nameK: 'k_342131',
    },
    {
        type: 'banner',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/banner_15_en.png',
        nameK: 'k_342284',
    },
    {
        type: 'extra',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/extra_new_5.png',
        nameK: 'k_362584',
        extraB: 5,
    },
];

export const rewardConfigTur = [
    {
        type: 'apple_reward',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/apple_small.png',
        nameK: 'k_344397',
    },
    {
        type: 'giftName',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/name_en.png',
        nameK: 'k_362580',
    },
    {
        type: 'kaiping',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/kaiping_7_tur.png',
        nameK: 'k_342131',
    },
    {
        type: 'banner',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/banner_15_tur.png',
        nameK: 'k_342284',
    },
    {
        type: 'extra',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/extra_new_5.png',
        nameK: 'k_362584',
        extraB: 5,
    },
];

export const rewardConfigBr = [
    {
        type: 'apple_reward',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/apple_small.png',
        nameK: 'k_344397',
    },
    {
        type: 'giftName',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/name_br.png',
        nameK: 'k_362580',
    },
    {
        type: 'kaiping',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/kaiping_7_br.png',
        nameK: 'k_342131',
    },
    {
        type: 'banner',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/banner_15_br.png',
        nameK: 'k_342284',
    },
    {
        type: 'extra',
        icon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/extra_50_5.png',
        nameK: 'k_362584',
        extraA: 50,
        extraB: 5,
    },
];

export const realRewardConfig = {
    egy: rewardConfigEgy,
    in: rewardConfigIn,
    pak: rewardConfigPak,
    tur: rewardConfigTur,
    br: rewardConfigBr,
};
